<template>
  <div
    class="z-10 grid gap-0 items-center bg-white text-xs font-medium text-gray-500 uppercase tracking-wider grid-cols-[20rem_repeat(5,minmax(5rem,1fr))_repeat(3,minmax(4.5rem,1fr))]"
  >
    <div class="px-6 py-3 text-left">
      {{ $t('ProjectSelector.ProjectDashboard.table.projectName') }}
    </div>

    <div class="px-6 py-3 text-left">
      {{ $t('ProjectSelector.ProjectDashboard.table.reference') }}
    </div>

    <div class="px-6 py-3 text-left">
      {{ $t('ProjectSelector.ProjectDashboard.table.status') }}
    </div>

    <div class="px-6 py-3 text-left">
      {{ $t('ProjectSelector.ProjectDashboard.table.contractStart') }}
    </div>

    <div class="px-6 py-3 text-left">
      {{ $t('ProjectSelector.ProjectDashboard.table.contractEnd') }}
    </div>

    <div class="px-6 py-3 text-left">
      {{ $t('ProjectSelector.ProjectDashboard.table.financialYear') }}
    </div>

    <div class="px-6 py-3 text-right">
      {{ $t('ProjectSelector.ProjectDashboard.table.budget') }}
    </div>

    <div class="px-6 py-3 text-right">
      {{ $t('ProjectSelector.ProjectDashboard.table.certified') }}
    </div>

    <div class="px-6 py-3 text-right">
      {{ $t('ProjectSelector.ProjectDashboard.table.residual') }}
    </div>
  </div>
</template>
